import { render } from "./index.vue?vue&type=template&id=1cff1372&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1cff1372&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1cff1372"

export default script